import { connect } from 'react-redux';
import { selectUserId, State as AccessTokenState } from '~/AccessToken';
import { ExchangeRates } from '~/Api/User/ExchangeRate';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { formatCondensedHumanDate } from '~/DateTime';
import { selectUnavailableDateError, State as ExchangeRateState } from '~/ExchangeRate/reducer';

import SelectModalControls from './SelectModalControls';

interface State {
	accessToken: AccessTokenState;
	exchangeRate: ExchangeRateState;
}

function mapStateToProps(
	state: State,
	props: {
		group: UserProductGroup;
		selectedRates: ExchangeRates | null;
		selectedDate: Date | null;
	}
) {
	const { group, selectedRates, selectedDate } = props;
	const userId = selectUserId(state.accessToken);

	return {
		unavailableDateError:
			selectedRates && userId
				? selectUnavailableDateError(state.exchangeRate, userId, group.id, selectedRates.type, selectedDate)
				: null,
		formatDate: formatCondensedHumanDate,
	};
}

export default connect(mapStateToProps)(SelectModalControls);
